export default __webpack_public_path__ + "static/media/Mask Group 8@2x.1ad8e838.png";